import type { SxProps, Theme } from '@mui/material';

import { borderRadius, shadows } from '@verantos-dev/shared-ui-components/tokens';

const cardChassis = {
  padding: 4,
  backgroundColor: 'background.paper',
  borderRadius: `${borderRadius.sm}px`,
  boxShadow: shadows.sm,
} as const;

/** Chat card chassis for the Review card, open or skipped: brand-primary left rail. */
export const reviewCardFrameSx: SxProps<Theme> = {
  ...cardChassis,
  borderLeft: (theme) => `3px solid ${theme.palette.primary.main}`,
};
